export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-format/src/identity.js
// module id = 375
// module chunks = 0